import { toolKeys } from '@lbmx/types';
export default {
  '/TestingModule': toolKeys.EDI_TESTING,
  '/AdministrationModule': toolKeys.ADMINISTRATION,
  '/userProfile': toolKeys.AUTHENTICATED,
};
